import {
  type ConsumerMessages,
  DeliverPolicy,
  type JetStreamClient,
  type JsMsg,
  type PushConsumer,
} from "@nats-io/jetstream";

import type { MarketQuoteClient } from "./MarketQuote.client";
import { MarketQuote } from "./MarketQuote.model";

interface NatsQuote {
  type: string;
  symbol: string;
  price: string;
}

export class StreamingMarketQuoteClient implements MarketQuoteClient {
  private subscribed = false;

  private quoteMap: Map<string, MarketQuote> = new Map<string, MarketQuote>();

  private consumer: PushConsumer | null = null;
  private consumerMessages: ConsumerMessages | null = null;

  constructor(readonly jetstreamClient: JetStreamClient) {}

  getMarketQuote(symbol: string): MarketQuote {
    const existingQuote = this.quoteMap.get(symbol);
    if (existingQuote) {
      return existingQuote!;
    }

    if (!this.subscribed) {
      this.subscribed = true;
      this.subscribe().catch(console.error);
    }

    const marketQuote = new MarketQuote("Crypto", symbol);
    this.quoteMap.set(symbol, marketQuote);
    return marketQuote;
  }

  private async subscribe(): Promise<void> {
    this.consumer = await this.jetstreamClient.consumers.getPushConsumer("MarketQuotes", {
      deliver_policy: DeliverPolicy.LastPerSubject,
    });
    this.consumerMessages = await this.consumer.consume({
      callback: (msg: JsMsg) => {
        const natsQuote = msg.json<NatsQuote>();
        let marketQuote = this.quoteMap.get(natsQuote.symbol);
        if (!marketQuote) {
          marketQuote = new MarketQuote("Crypto", natsQuote.symbol);
          this.quoteMap.set(natsQuote.symbol, marketQuote);
        }
        marketQuote.setPrice(natsQuote.price);
      },
    });
  }
}
